export const fetchFrontendIsOutOfDate = (): Promise<string | null> =>
  fetch(window.location.origin)
    .then((r) => r.headers.get("Last-Modified"))
    .catch(() => null);
